import { HTMLAttributes, useState } from "react";
import { CommonInstallflowFrame } from "./common-install-flow-frame";
import previousTutorialImage from "@/assets/previous-tutorial.png";
import { useNavigate } from "@tanstack/react-router";
import { Clock } from "lucide-react";
import { apiClient } from "@/api/client";
import ThaloIcon from "@/assets/thalo_icon.svg";
import {
  installFlowOrganizationId,
  installFlowLocationId,
  installFlowSublocationId,
  installFlowSensorKitSerial,
  installFlowScanId,
  installFlowInstallationId,
} from "@/installFlow/storage-keys";

interface AuthProps extends HTMLAttributes<HTMLDivElement> {}

export function CompletePhysicalInstall({ className }: AuthProps) {
  const navigate = useNavigate();
  const [isLinking, setIsLinking] = useState(false);
  const [linkError, setLinkError] = useState<string | null>(null);

  const handleNext = () => {
    navigate({ to: "/installFlow/live-data" });
  };

  const handleSkip = async () => {
    setIsLinking(true);
    setLinkError(null);
    try {
      const organizationId = installFlowOrganizationId.get();
      const locationId = installFlowLocationId.get();
      const sublocationId = installFlowSublocationId.get();
      const serialNumber = installFlowSensorKitSerial.get() ?? "";
      const scanId = installFlowScanId.get() ?? "";
      const installationId = installFlowInstallationId.get() ?? "";

      await apiClient.post(
        `organizations/${organizationId}/locations/${locationId}/sublocations/${sublocationId}/installations/${installationId}/link-sensor-kit/`,
        { scan_id: scanId, sensor_kit_serial_number: serialNumber },
      );

      await navigate({ to: "/installFlow/final-check" });
    } catch {
      setLinkError("Failed to link the sensor. Please try again.");
      setIsLinking(false);
    }
    
  };

 

  return (
    <CommonInstallflowFrame className="flex-col min-h-[calc(100vh-64px)]">
      {/* Scrollable content */}
      <div className="flex flex-col gap-4 w-full">
    
      

        {/* Text content */}
        <h1 className="text-xl font-bold text-black leading-tight">
          Did you complete the physical install?
        </h1>
        <p className="text-base text-gray-500 leading-snug font-semibold">
        Make sure the sensor light is solid blue. On the next screen, we’ll do a final check.
        </p>

        {/* Time badge */}
        <button
            onClick={() => console.log("Need help?")}
            className="w-28 h-12 rounded-full border border-gray-300 bg-white text-gray-500 text-base font-medium hover:bg-gray-50 transition-colors px-2 py-3"
          >
            Need help?
          </button>
      </div>

      {/* Bottom buttons */}
      <div className="flex flex-col gap-3 w-full pt-8 pb-2 h-[400px] justify-end">
        <button
          type="button"
          onClick={handleNext}
          className="w-full rounded-full bg-[#0053EE] py-4 text-white text-base font-semibold hover:bg-blue-700 transition-colors"
        >
          Confirm & Continue
        </button>
      
      </div>
    </CommonInstallflowFrame>
  );
}
